import { basePath } from "./config";
import axios from "axios";
import { getTokenCiudadano } from "./auth";
import { TIPO_SEDE } from "../utils/constanst";

const TIPO_INTEGRANTE = [1];
const TIPO_STATUS = [1];

export function saveRequest(request) {
  const url = `${basePath}/solicitud`;
  const jwt = getTokenCiudadano();
  return axios.post(url, request, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt,
      Origen: "portal",
      Parametrizacion: "0,0",
    },
  });
}

export function updateRequest(request) {
  const url = `${basePath}/solicitud/actualizar`;
  const jwt = getTokenCiudadano();
  return axios.post(url, request, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt,
      Origen: "portal",
      Parametrizacion: "0,0",
    },
  });
}

export const getOrganitation = (codigo) => {
  const url = `${basePath}/solicitud/organizacion`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { codigo: codigo },
    {
      headers: {
        Authorization: jwt,
        Origen: "portal",
        Parametrizacion: "0,0",
      },
    }
  );
};

export function getStatus(correo) {
  const url = `${basePath}/solicitud/estatus`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { correo: correo },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getCursoPresencial(correo) {
  const url = `${basePath}/cursos/cursoPresencialCiudadano`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { correo: correo },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getState() {
  const url = `${basePath}/geografico`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    {},
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}


export function getOrganizacion(codigoOrganizacion) {
  const url = `${basePath}/solicitud/getOrganizacion`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { codigoOrganizacion: codigoOrganizacion },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getEntidadesSeg() {
  const url = `${basePath}/solicitud/entidadesSeguimiento`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    {},
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getMunicipio(idEstado) {
  const url = `${basePath}/municipio`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { idEstado: idEstado },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getDownload(usuario, tipo, idObs) {
  const url = `${basePath}/solicitud/descarga`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { usuario: usuario, tipo: tipo, idObservador: idObs },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: jwt,
        Origen: "portal",
        Parametrizacion: "0,0",
      },
      responseType: "blob",
    }
  );
}

export function getStudies() {
  const url = `${basePath}/solicitud/escolaridad`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    {},
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getByJunta(idEstado, idCorte) {
  //const url = `${urlJuntas}/ws/domiciliosJunta/consulta`;
  //const url = `${basePath}/solicitud/junta`;
  //const url = `${basePath}/sesiones/domicilio`;
  const url = `${basePath}/sesiones/juntaEjecutiva`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { idEstado: idEstado, tipoSede: TIPO_SEDE, idCorte: idCorte },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

/* export function getByJuntaTablasLoc(idEstado) {
  const url = `${basePath}/sesiones/juntaEjecutivaTablasLoc`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { idEstado: idEstado, tipoSede: TIPO_SEDE },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
} */

export function getByIdDistrito(idEstado, seccion) {
  const url = `${basePath}/solicitud/distrito`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { idEntidad: idEstado, seccion: seccion },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export const getEntities = (idProceso, idDetalle) => {
  const url = `${basePath}/solicitud/observar`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    {
      idProceso:idProceso,
      idDetalle:idDetalle,
    },
    {
      headers: {
        Authorization: jwt,
        Origen: "portal",
        Parametrizacion: "0,0",
      },
    }
  );
};

// export function getFuncionarios(idEstado, idJunta) {
//   //const url = `${urlJuntas}/ws/integrantes/consulta`;
//   //const url = `${basePath}/cursos/funcionarios`;
//   const url = `${basePath}/sesiones/funcionarios`;
//   const jwt = getTokenCiudadano();
//   return axios.post(
//     url,
//     {
//       tipoIntegrante: TIPO_INTEGRANTE,
//       idEstado: idEstado,
//       idDistritoFederal: idJunta,
//       estatus: TIPO_STATUS
//     },
//     {
//       headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
//     }
//   );
// }
////////////////////////// SERVICIOS PARA LA SOLICITUD EXTRANJERA //////////////////////////
export const getCountries = () => {
  const url = `${basePath}/solicitud/paises`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    {},
    {
      headers: {
        Authorization: jwt,
        Origen: "portal",
        Parametrizacion: "0,0",
      },
    }
  );
};
////////////////////////// SERVICIOS OBSERVACIONES EN EL REGISTRO CIUDADANO //////////////////////////
export function getByMailRegister(mail) {
  const url = `${basePath}/observaciones`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { correo: mail },
    {
      headers: {
        Authorization: jwt,
        Origen: "portal",
        Parametrizacion: "0,0",
      },
    }
  );
}

export function getJuntas(idEstado, idJunta, idCorte) {
  const url = `${basePath}/sesiones/juntaEjecutiva`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { idEstado: idEstado, idDistritoFederal: idJunta, tipoSede: TIPO_SEDE, idCorte: idCorte },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getFuncionarios(idProceso, idDetalle, idEstado, idJunta) {
  const url = `${basePath}/sesiones/funcionarios`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    {
      id_proceso: idProceso, 
      id_detalle: idDetalle,
      tipoIntegrante: TIPO_INTEGRANTE,
      idEstado: idEstado,
      idDistritoFederal: idJunta,
      estatus: TIPO_STATUS
    },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function validaClaveMail(values, modulo) {
  const url = `${basePath}/registroJuntas/validaClaveMail`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { values: values, modulo: modulo },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getPaises() {
  const url = `${basePath}/observaciones/paises`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    {},
    {
      headers: {
        Authorization: jwt,
        Origen: "portal",
        Parametrizacion: "0,0",
      },
    }
  );
}

export function updateChanges(register) {
  const url = `${basePath}/observaciones/actualizar`;
  const jwt = getTokenCiudadano();
  return axios.post(url, register, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt,
      Origen: "portal",
      Parametrizacion: "0,0",
    },
  });
}

export function getEstadoGralSolicitud(correo) {
  const url = `${basePath}/solicitudes/getEstadoGralSolicitudPortal`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { correo: correo },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getEstadoCursoLinea(ciudadano){
  const url = `${basePath}/solicitud/estatusCursoLinea`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { id: ciudadano.id },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function getTieneAsistencia(correo) {
  const url = `${basePath}/solicitudes/getTieneAsistencia`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { correo: correo },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}


export function getEstadoCurso(id) {
  const url = `${basePath}/cursos/linea/continuarCurso`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { idObservador: id },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

//FUNCION PARA SABER SI SE PUEDE COMENZAR EL CURSO
export function getEstadoMateriales(){
  const url=`${basePath}/cursos/linea/EstadoMateriales`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    {},
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

// Debido a la premura, se reutiliza la función de la junta ejecutiva que consulta la información al modificar una solicitud 
export function getDatosObservador(id) {
  const url = `${basePath}/registroJuntas/id`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    /* { idObservador: id, idProceso: "19", idDetalle: "142" }, */
    { idObservador: id },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
}

export function guardarOCP(datos) {
  const url = `${basePath}/solicitud/actualizarObCP`;
  const jwt = getTokenCiudadano();
  return axios.post(url, datos, {
    headers: { Authorization: jwt,  Origen: "portal", Parametrizacion: "0,0" },
  });
}

export function obtenDetallesPorProcesoPortal(idProceso) {
  const url = `${basePath}/registroJuntas/obtenDetallesPorProceso`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { idProceso: idProceso },
    { headers: { Authorization: jwt, Origen: "portal" } }
  );
}

export function obtenFechaJornada(idProceso, idDetalle) {
  const url = `${basePath}/solicitud/fechaJornada`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    { idProceso: idProceso, idDetalle: idDetalle },
    { headers: { Authorization: jwt, Origen: "portal" } }
  );
}

export function getParametroPortal(idProceso, idDetalle, parametro) {
  const url = `${basePath}/parametro`;
  const jwt = getTokenCiudadano();
  return axios.post(url, 
    { idProceso: idProceso, idDetalle: idDetalle, parametro: parametro },
    { headers: { Authorization: jwt,  Origen: "portal", Parametrizacion: "0,0" } }
  );
}

export function getPaisesVotoExtranjero() {
  const url = `${basePath}/registroJuntas/paisesVotoExtranjero`;
  const jwt = getTokenCiudadano();
  return axios.post( url, {}, { headers: { Authorization: jwt }});
}

export function getSedesVotoExtranjero(idPais) {
  const url = `${basePath}/registroJuntas/sedesVotoExtranjero`;
  const jwt = getTokenCiudadano();
  return axios.post( url, {idPais: idPais}, { headers: { Authorization: jwt }});
}

export function obtenerURLImagen(imagen) {
  const url = `${basePath}/solicitud/imagen`;
  const jwt = getTokenCiudadano();
  return axios.post(
    url,
    imagen,
    { headers: { Authorization: jwt } }
  );
}
